import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { SessionService } from '@services/session.service';

@Component({
  selector: 'app-error-handling-dialog',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './error-handling-dialog.component.html',
  styleUrl: './error-handling-dialog.component.scss'
})
export class ErrorHandlingDialogComponent {
  id: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ErrorHandlingDialogComponent>,
    private sessionService: SessionService,
    private router: Router
  ) {
    this.id = 'QuotesError';
  }

  // This method is used to close the dialog
  cancelDialog(target?: string): void {
    this.dialogRef.close(!!target ? target : '');
  }

  // Navigate to home page
  navigateToHome(): void {
    // clear session and local storage
    this.sessionService.clearData();
    this.sessionService.clearSessionStorage();
    this.sessionService.clearLocalStorage();

    this.router.navigate(['/']);
    // Close the dialog and navigate to home
    this.dialogRef.close('navigateToHome');
  }
}
